export function createRenditionUrl(url) {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const baseUrl = `${url.substring(0, url.lastIndexOf('/'))}_renditions${url.substring(url.lastIndexOf('/'), url.lastIndexOf('.'))}`;
        let newUrl = url;
        const renditionMap = [ {width: 1280, height: 720}, {width: 882, height: 496} ]

        for (let rendition of renditionMap) {
            if (rendition['width'] >= windowWidth && rendition['height'] >= windowHeight) {
                newUrl = `${baseUrl}_${rendition['width']}x${rendition['height']}.jpg`;
            } else { 
                break; 
            }
        }
        return newUrl;
}